export default "__VITE_ASSET__$I8ObqqT__$_?no-inline__"